export default {
  zh: {
    layoutDetail: '{type}详情',
    tools: '工具栏',
    modules: '模块',
    sections: '内容块',
    layout: '布局',
    pageLayout: '页面布局',
    layoutName: '布局名',
    section: '内容块',
    assingmentLayout: '设置布局',
    existingLayout: '继承布局',
    section_col: '内容块栏数',
    col1: '1 栏',
    col2: '2栏',
    operates: {
      preview: '预览',
      tools: '工具栏',
      sections: '内容块',
      modules: '功能模块',
    },
    pageLayoutOptionTips: {
      tools: '添加工具栏，新功能会添加到{type}视图页面',
      sections: '添加需要显示的字段到布局页面',
      modules: '添加功能模块会添加该功能模块的所有功能到布局页面',
    },
    pageLayoutNotification: {
      tools: '你还没有 <i>工具</i>，拖动右面 <i>工具栏</i> 至此处',
      modules: '你还没有 <i>模块</i>，拖动右面 <i>功能模块</i> 至此处'
    },
    pageLayoutAssignment: '分配布局到部门',
    selectPageLayout: '请选择一个布局',
    addSectionDialogTitle: '新增内容块',
    editSectionDialogTitle: '编辑内容块',
    editField: '编辑字段',
    cancelEditing: '你还未保存你所做的更改，确定放弃？',
    createNewPageLayout: '创建新布局',
    saveAndNext: '保存并进行下一步',
    edit: {
      required: '必填',
      readOnly: '只读',
    },
  },
  en: {
    layoutDetail: '{type} Detail',
    tools: 'Tools',
    modules: 'Modules',
    sections: 'Sections',
    layout: 'Layout',
    pageLayout: 'Page Layout',
    layoutName: 'Layout Name',
    section: 'Section',
    assingmentLayout: 'Page Layout Assignment',
    existingLayout: 'Existing Layout',
    section_col: 'Section Column',
    col1: '1 Column',
    col2: '2 Column',
    operates: {
      preview: 'Preview',
      tools: 'Tools',
      sections: 'Fields/Sections',
      modules: 'Modules',
    },
    pageLayoutOptionTips: {
      tools: 'By adding Tools, new function will be added into View {type}',
      sections: ' Adding new Fields/Sections into your Page Layout',
      modules: 'Adding new Modules will have all Module Functions',
    },
    pageLayoutNotification: {
      tools: 'There is no <i>Tool</i>, drag over from the right side <i>Tools</i> panel',
      modules: 'There is no <i>Module</i>, drag over from the right side <i>Modules</i> panel'
    },
    pageLayoutAssignment: 'Page Layout assignment',
    selectPageLayout: 'Please select a page layout',
    addSectionDialogTitle: 'Add Section',
    editSectionDialogTitle: 'Edit Section',
    editField: 'Edit Field',
    cancelEditing: 'You haven\'t save your modification ,are you sure exit？',
    createNewPageLayout: 'Create New Page Layout',
    saveAndNext: 'Save and Next',
    edit: {
      required: 'Required',
      readOnly: 'Read Only',
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/Setup/PageLayout/i18n.js